import React, { useEffect } from 'react';
import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { I18nextProvider } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getLocale } from '../store/app/selectors';

import deDE from './locales/de_DE/translation.json';
import enUS from './locales/en_US/translation.json';

const isBrowser = typeof window !== 'undefined';

if (isBrowser) {
    i18next.use(HttpBackend);
}

i18next.init({
    backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: {
        useSuspense: false,
    },
    debug: process.env.NODE_ENV === 'development' && isBrowser,
    fallbackLng: 'en_US',
    fallbackNS: ['translation'],
    partialBundledLanguages: true,
    resources: {
        de_DE: { translation: deDE },
        en_US: { translation: enUS },
    },
    parseMissingKeyHandler: (missing: string) => {
        if (process.env.NODE_ENV === 'development' && isBrowser) {
            console.warn('MISSING TRANSLATION:', missing);
        }
        return missing;
    },
});

i18next.languages = ['de_DE', 'en_US'];

const I18N: React.FC<React.PropsWithChildren> = ({ children }) => {
    const locale = useSelector(getLocale);
    useEffect(() => {
        void i18next.changeLanguage(locale);
    }, [locale]);

    return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>;
};

export default React.memo(I18N);
